import React from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  ButtonContainer,
  Title,
  Card,
  LinkButton,
} from "shared/components";
import { Spacer } from "shared/layout";
import { copy } from "shared/assets";
import { CenterContent, MutedText } from "shared/styles";
import { ITheme } from "shared/types";
import { PATHS } from "App/router";

interface FourOhFourProps {
  message?: string;
  dataTestId?: string;
}

const FourOhFour: React.FC<FourOhFourProps> = ({ message, dataTestId }) => {
  const history = useHistory();

  return (
    <CenterContent data-testid={dataTestId || "four_oh_four_page"}>
      <Card>
        <Spacer size="m">
          <Title title={copy.fourOhFour.title} />
          <MutedText as="p">{message || copy.fourOhFour.general}</MutedText>
          <ButtonContainer>
            {history.length > 2 && (
              <Button onClick={history.goBack} theme={ITheme.secondary}>
                {copy.fourOhFour.back}
              </Button>
            )}
            <LinkButton to={PATHS.HOME}>{`${copy.fourOhFour.home}`}</LinkButton>
          </ButtonContainer>
        </Spacer>
      </Card>
    </CenterContent>
  );
};

export default FourOhFour;
